// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\CoordinationAltStatusLabel\ApiCoordinationAltStatusLabel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Coordination, CoordinationData, CoordinationOptions } from 'data/models/Coordination';
import { CoordinationCardStatus, CoordinationCardStatusData, CoordinationCardStatusOptions } from 'data/models/CoordinationCardStatus';

// CoordinationAltStatusLabelData is the class that CoordinationAltStatusLabel serializes to/from
export interface CoordinationAltStatusLabelData {
    CoordinationId : number;
    StatusId : number;
	
    Coordination : CoordinationData | null;
    Status : CoordinationCardStatusData | null;
	
    Label : string;
}

// CoordinationAltStatusLabelOptions is the class which may be passed to the CoordinationAltStatusLabel constructor to define optional initial data values
export interface CoordinationAltStatusLabelOptions {
    CoordinationId : number;
    StatusId : number;
	
    Coordination? : CoordinationOptions | null;
    Status? : CoordinationCardStatusOptions | null;
	
    Label? : string;
}

export class CoordinationAltStatusLabel {
    public CoordinationId : DataSignal<number>;
    public StatusId : DataSignal<number>;
	
    public Coordination : DataSignal<Coordination | null>;
    public Status : DataSignal<CoordinationCardStatus | null>;
	
    public Label : DataSignal<string>;

    constructor();
    constructor(data : CoordinationAltStatusLabelOptions);
    constructor(data: CoordinationAltStatusLabelOptions | null = null) {
        this.CoordinationId = jsonableObservable(S.value<number>(data && data.CoordinationId !== undefined ? data.CoordinationId : 0));
        this.StatusId = jsonableObservable(S.value<number>(data && data.StatusId !== undefined ? data.StatusId : 0));
	    
        this.Coordination = S.value<Coordination | null>(null);
        this.Status = S.value<CoordinationCardStatus | null>(null);
	    
        this.Label = jsonableObservable(S.value<string>(data && data.Label !== undefined ? data.Label : ''));
    }

    static key(obj : CoordinationAltStatusLabel) {
        return obj.CoordinationId() + '\u2618' + obj.StatusId();
    }
    
    static dataKey(obj : CoordinationAltStatusLabelOptions) {
        return obj.CoordinationId + '\u2618' + obj.StatusId;
    }

    static update(obj : CoordinationAltStatusLabel, data : CoordinationAltStatusLabelOptions) {
        S.freeze(() => {
            if (data.CoordinationId !== undefined) obj.CoordinationId(data.CoordinationId);
            if (data.StatusId !== undefined) obj.StatusId(data.StatusId);
	        
	        
            if (data.Label !== undefined) obj.Label(data.Label);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/CoordinationAltStatusLabel.ts